import { Component, OnDestroy, OnInit } from '@angular/core';

/**
 * Muestra Página para el error 401 (Sin Permisos) sobre la funcionalidad
 */
@Component( {
  selector: 'app-sin-autorizacion',
  templateUrl: 'sinAutorizacion.component.html',
} )
export class SinAutorizacionComponent implements OnInit, OnDestroy {
  /**
   * Función de Inicio de la funcionalidad
   */
  ngOnInit(): void {
    $( 'body' ).addClass( 'page-no-auth' );
  }

  /**
   * Función que se ejecuta al salir de la funcionalidad
   */
  ngOnDestroy() {
    $( 'body' ).removeClass( 'page-no-auth' );
  }
}
